import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Legal.css';

function TermsAndConditions() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="logo" onClick={() => navigate('/')}>
          <img src="/JobLinkedAI.png" alt="JobLinked AI" />
          JobLinked AI
        </div>
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </nav>

      <div className="legal-hero">
        <h1>Terms &amp; Conditions</h1>
        <p>Please read these terms carefully before using JobLinked AI</p>
      </div>

      <div className="legal-content">
        <span className="legal-effective">Effective Date: 18 April 2025</span>

        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using JobLinked AI ("the Platform", "we", "us", "our"), you agree to be bound by these Terms and Conditions and all applicable South African laws and regulations. If you do not agree with any part of these terms, you may not use the Platform.</p>
          <p>These terms apply to all users of the Platform, including job seekers, recruiters, and visitors.</p>
        </div>

        <div className="legal-section">
          <h2>2. Description of Service</h2>
          <p>JobLinked AI is an AI-powered job matching and recruitment platform that connects job seekers with South African employers and recruiters. Our services include:</p>
          <ul>
            <li>AI-powered job matching based on CV analysis</li>
            <li>Job application tracking and management</li>
            <li>Direct messaging between job seekers and recruiters</li>
            <li>Document management and storage</li>
            <li>Subscription-based premium features</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. User Accounts</h2>
          <h3>3.1 Registration</h3>
          <p>You must provide accurate, complete, and current information when creating an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>
          <h3>3.2 Eligibility</h3>
          <p>You must be at least 18 years of age to use this Platform. By registering, you confirm that you meet this requirement.</p>
          <h3>3.3 Account Termination</h3>
          <p>We reserve the right to suspend or terminate accounts that violate these terms, engage in fraudulent activity, or misuse the Platform in any way.</p>
        </div>

        <div className="legal-section">
          <h2>4. Job Seekers</h2>
          <p>As a job seeker, you agree to:</p>
          <ul>
            <li>Provide truthful and accurate information in your profile and CV</li>
            <li>Not misrepresent your qualifications, experience, or identity</li>
            <li>Use the Platform solely for legitimate job-seeking purposes</li>
            <li>Not submit applications to positions you are not genuinely interested in</li>
            <li>Respond to interview invitations in a timely and professional manner</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>5. Recruiters</h2>
          <p>As a recruiter, you agree to:</p>
          <ul>
            <li>Post only genuine, lawful job opportunities</li>
            <li>Not discriminate against applicants on the basis of race, gender, age, disability, religion, or any other protected characteristic under South African law</li>
            <li>Comply with the Employment Equity Act, Basic Conditions of Employment Act, and all applicable labour legislation</li>
            <li>Handle candidate personal information in accordance with POPIA</li>
            <li>Not use candidate data for purposes other than recruitment</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. Subscriptions and Payments</h2>
          <h3>6.1 Billing</h3>
          <p>Paid subscriptions are billed monthly via Paystack. By subscribing, you authorise recurring charges to your selected payment method.</p>
          <h3>6.2 Cancellation</h3>
          <p>You may cancel your subscription at any time. Cancellation takes effect at the end of the current billing period. No refunds are issued for partial months.</p>
          <h3>6.3 Price Changes</h3>
          <p>We reserve the right to change subscription prices with 30 days' notice. Continued use after the notice period constitutes acceptance of the new pricing.</p>
        </div>

        <div className="legal-section">
          <h2>7. Intellectual Property</h2>
          <p>All content on the Platform, including but not limited to the logo, design, algorithms, and software, is the intellectual property of JobLinked AI and is protected under South African copyright law. You may not reproduce, distribute, or create derivative works without our express written consent.</p>
          <p>You retain ownership of content you upload (CVs, documents, profile information) but grant us a limited licence to process and display it for the purpose of providing the service.</p>
        </div>

        <div className="legal-section">
          <h2>8. Prohibited Conduct</h2>
          <p>You may not:</p>
          <ul>
            <li>Use the Platform for any unlawful purpose</li>
            <li>Scrape, crawl, or harvest data from the Platform</li>
            <li>Attempt to gain unauthorised access to any part of the Platform</li>
            <li>Upload malicious code, viruses, or harmful content</li>
            <li>Harass, threaten, or abuse other users</li>
            <li>Create fake profiles or impersonate others</li>
            <li>Use automated tools to submit applications without genuine intent</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>9. Disclaimer of Warranties</h2>
          <p>The Platform is provided "as is" without warranties of any kind. We do not guarantee that job matches will result in employment, that all job postings are accurate, or that the Platform will be uninterrupted or error-free.</p>
        </div>

        <div className="legal-section">
          <h2>10. Limitation of Liability</h2>
          <p>To the maximum extent permitted by South African law, JobLinked AI shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Platform, including loss of employment opportunities or data.</p>
        </div>

        <div className="legal-section">
          <h2>11. Governing Law</h2>
          <p>These Terms are governed by the laws of the Republic of South Africa. Any disputes shall be subject to the exclusive jurisdiction of the South African courts.</p>
        </div>

        <div className="legal-section">
          <h2>12. Changes to Terms</h2>
          <p>We may update these Terms at any time. We will notify registered users via email of material changes. Continued use of the Platform after changes constitutes acceptance.</p>
        </div>

        <div className="legal-contact-box">
          <p>Questions about these Terms? Contact us at <a href="mailto:legal@joblinked.ai">legal@joblinked.ai</a></p>
        </div>
      </div>

      <footer className="legal-footer">
        <p>&copy; 2025 JobLinked AI. All rights reserved. Built with ❤️ in South Africa</p>
        <p style={{ marginTop: '0.5rem' }}>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </p>
      </footer>
    </div>
  );
}

export default TermsAndConditions;
